import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_XA',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '6901597f-ca58-4208-bab4-71a935c18a54',
  ''
);
